/**
 * A page shared to the iOS app (its share extension's readlang://browse?url=…,
 * which the app loads as /browse?url=…). It's kept for this session until the
 * user is signed in and has agreed to AI (aiConsent.ts), then opened in the
 * app's browser: signed out, the Web Reader couldn't translate, and opening
 * the browser over the consent sheet would dismiss it.
 */
import * as iOSBridge from "iOSBridge";
import stores from "stores/stores";

const storageKey = "sharedPage";

/** Keeps a web page shared to the iOS app, to open once it can be */
export const keep = (url: string | null) => {
  if (iOSBridge.get() && url && /^https?:\/\//i.test(url)) {
    sessionStorage.setItem(storageKey, url);
  }
};

/**
 * Opens the page kept, if the user has agreed to AI (so is signed in: the
 * local, signed-out user never has)
 */
export const open = () => {
  const url = sessionStorage.getItem(storageKey);
  const app = iOSBridge.get();
  if (url && app && stores.user.state.value.aiConsentedAt) {
    sessionStorage.removeItem(storageKey);
    app.openBrowser(url);
  }
};
